import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import Tooltip from 'Pods/Shared/Tooltip'
import Loader from 'Pods/Shared/Loader'

import ListItem from './ListItem'
import JobInfo from './JobInfo'

class JobsTabs extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      isDataFetched: false,
      axiosSource: axios.CancelToken.source(),
      activeTab: this.props.tabs[0].slug,
      activeJobDescription: {},
    }

    this.fetchData = this.fetchData.bind(this)
    this.onTabClick = this.onTabClick.bind(this)
    this.selectJob = this.selectJob.bind(this)
  }

  componentDidMount() {
    this.fetchData(this.state.activeTab)
  }

  fetchData(tabStatus) {
    return axios.get('/api/internal/seller_dashboard/jobs', {
      params: {
        status: tabStatus,
      },
      cancelToken: this.state.axiosSource.token,
    })
      .then((response) => this.onFetchSuccess(response))
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    response.data && response.data.length === 0 ? (
      this.setState({
        data: response.data,
        isDataFetched: true,
      })
    ) : (
      this.setState({
        data: response.data,
        isDataFetched: true,
        activeJobDescription: {
          title: response.data[0].title,
          status: response.data[0].status,
          description: response.data[0].description,
          lastMessage: response.data[0].last_message,
          attachments: response.data[0].job_attachments,
          offer: response.data[0].offer,
          revenue: response.data[0].revenue,
          deadlineDate: response.data[0].deadline_date,
          type: response.data[0].type,
          slug: response.data[0].slug,
          applicationId: response.data[0].job_application_id,
        },
      })
    )
    this.props.setShowMore(response.data.length > 0)
  }

  tabClassName(tabPanelComponentSlug) {
    return this.state.activeTab === tabPanelComponentSlug ? 'tab is-active' : 'tab'
  }

  onTabClick(slug) {
    this.props.setShowMore(false)
    this.setState({
      activeTab: slug,
      isDataFetched: false,
    })
    this.fetchData(slug)
  }

  selectJob(job) {
    const newActiveJob = this.state.data.filter((item) => item.title === job)

    this.setState({
      activeJobDescription: {
        title: newActiveJob[0].title,
        status: newActiveJob[0].status,
        description: newActiveJob[0].description,
        lastMessage: newActiveJob[0].last_message,
        attachments: newActiveJob[0].job_attachments,
        offer: newActiveJob[0].offer,
        revenue: newActiveJob[0].revenue,
        deadlineDate: newActiveJob[0].deadline_date,
        type: newActiveJob[0].type,
        slug: newActiveJob[0].slug,
        applicationId: newActiveJob[0].job_application_id,
      },
    })
  }

  render() {
    return (
      <div>
        <div className="tabs-container">
          <ul className="nav-tabs nav-tabs--small">
            {this.props.tabs.map((tab) => {
              return (
                <li key={tab.slug} className={this.tabClassName(tab.slug)}>
                  <a onClick={() => { this.onTabClick(tab.slug) }}>
                    <Tooltip
                      className="u-block"
                      tooltipClassName="tooltip--medium"
                      id={`dashboard__top-designers-tab--${tab.slug}`}
                      content={tab.text}
                    >
                      {tab.title}
                    </Tooltip>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        <div className="tabs-content">
          <div className="tab-pane is-active">
            {!this.state.isDataFetched ? (
              <Loader />
            ) : (
              this.state.data.length === 0 ? (
                <div className="empty-content u-text-center">
                  <p className="text-semibold">You have not applied to any 3D Projects. Browse available
                    <a href="/3d-modeling-jobs/browse" className="link--primary-dark"> requests here</a>
                  </p>
                </div>
              ) : (
                <div className="jobs-list">
                  <div className="row">
                    <div className="col-12 col-sm-7">
                      {this.state.data.map((item) => (
                        <ListItem
                          key={item.title}
                          data={item}
                          active={this.state.activeJobDescription.title}
                          selectJob={this.selectJob}
                        />
                      ))}
                    </div>
                    <JobInfo data={this.state.activeJobDescription} type={this.state.activeTab} />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }
}

JobsTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  setShowMore: PropTypes.func.isRequired,
}

export default JobsTabs
